import { PureComponent } from 'react';

import { generateUniqueHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import { isNullable } from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import withLogError from 'containers/ErrorBoundary/withLogError';
import { makeSelectMessages } from 'containers/LanguageProvider/selectors';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import handleEvent from 'utils/handleEvent';
import { makeSelectUploading } from './selectors';

class FileUploadOverlay extends PureComponent {
  static defaultProps = {
    uploading: false,
  };

  fileNameInputId = generateUniqueHtmlId('fileName');

  static propTypes = {
    msg: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onLogError: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    uploading: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      fileUpload: null,
      fileUploadName: '',
    };
  }

  handleNameChange = handleEvent(({ target: { value } }) => {
    this.setState({ fileUploadName: value });
  });

  handleUploadChange = handleEvent((e) => {
    const file = get(e, ['target', 'files', 0]);
    if (isNullable(file)) {
      this.setState({ fileUpload: null });
      return;
    }
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        if (evt.target.readyState !== 2) {
          return;
        }
        if (evt.target.error) {
          return;
        }
        this.setState({ fileUpload: evt.target.result });
      } catch (error) {
        this.props.onLogError(error);
      }
    };
    reader.readAsText(file);
  });

  handleUpload = () => {
    const { onUpload } = this.props;
    const { fileUpload, fileUploadName } = this.state;
    onUpload(fileUploadName, fileUpload);
  };

  render() {
    const {
      msg: { fileUploadOverlay: msg },
      onClose,
      uploading,
    } = this.props;
    const { fileUploadName, fileUpload } = this.state;
    return (
      <OverlayModal onClose={onClose}>
        <OverlayModalHeader>
          <h4 className='box-title'>{get(msg, 'fileUpload')}</h4>
        </OverlayModalHeader>
        <OverlayModalBody>
          <div className='form-group'>
            <label className='block' htmlFor={this.fileNameInputId}>
              {get(msg, 'name')}
            </label>
            <input
              id={this.fileNameInputId}
              className='form-control'
              onChange={this.handleNameChange}
              type='text'
              value={fileUploadName}
            />
          </div>
          <div>
            <input type='file' onChange={this.handleUploadChange} />
          </div>
        </OverlayModalBody>
        <OverlayModalFooter>
          <Button
            disabled={!fileUploadName || !fileUpload}
            type='button'
            variant='primary'
            onClick={this.handleUpload}
            loading={uploading}
            className='mr-2'
          >
            {get(msg, 'btnSave')}
          </Button>
          <Button type='button' variant='secondary' onClick={onClose}>
            {get(msg, 'btnCancel')}
          </Button>
        </OverlayModalFooter>
      </OverlayModal>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  msg: makeSelectMessages(),
  uploading: makeSelectUploading(),
});

export default connect(mapStateToProps)(withLogError(FileUploadOverlay));
